import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["all", "name", "source", "status", "size"];

  submitForKeydown (keyboardEvent) {
    if (["Enter", "Return"].includes(keyboardEvent.key)) {
      this.submit();
    }
  }

  submit () {
    this.setAllLeads();
    this.element.submit();
  }

  // Size buckets only exist inside the pending-broker-email fold, so changing
  // status leaves the queue and must not carry the bucket onto a status where
  // it means nothing. Changing source stays in the queue, so it keeps it.
  submitForStatus () {
    this.sizeTarget.value = "";
    this.submit();
  }

  setAllLeads () {
    if (this.hasSource() || this.hasStatus() || this.nameTarget.value) {
      this.allTarget.value = "true";
    }
  }

  hasSource () {
    return this.sourceTarget.value;
  }

  hasStatus () {
    return this.statusTarget.value && this.statusTarget.value !== "all";
  }
}
